import { SupportedLanguages } from '../../i18n/constants';
import type { LanguageOption } from '../LanguageSelect/types';

export const ENGLISH_LANGUAGE_OPTION: LanguageOption = {
  id: SupportedLanguages.EN,
  name: 'English',
  shortCode: SupportedLanguages.EN,
};
export const GERMAN_LANGUAGE_OPTION: LanguageOption = {
  id: SupportedLanguages.DE,
  name: 'Deutsch',
  shortCode: SupportedLanguages.DE,
};
export const LANGUAGES_OPTIONS: LanguageOption[] = [ENGLISH_LANGUAGE_OPTION, GERMAN_LANGUAGE_OPTION];
